const actions = {
    TABS_FETCH_ACTIVE_KEY: (state) => state,
    TABS_CHANGE: (state, {activeKey}) => {
        const newActiveKey = activeKey || state.activeKey;

        return {
            ...state,
            activeKey: newActiveKey,
        };
    },
};

const reducer = (
    state = {
        activeKey: 1,
    }, action
) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
